/**
 * @file: MessageTimeMarker.tsx
 *
 * Centered time-slice marker rendered between messages whose gap exceeds
 * the slice threshold (and before the first message).
 */

import { Typography } from '@euler/app/components/typography';
import { formatChatTime } from '@euler/app/flows/chat/utils/formatChatTime';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

export const MessageTimeMarker: FC<{
  createdAt: string;
  style?: StyleProp<ViewStyle>;
}> = memo(({ createdAt, style }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View style={[{ alignItems: 'center' }, style]}>
      <Typography.Text
        size={rpx(11)}
        color="#9ca3af"
        style={{ fontFamily: FontFamily.NotoSans.Regular }}
      >
        {formatChatTime(createdAt)}
      </Typography.Text>
    </View>
  );
});
